import { useLocation, useSearchParams } from 'react-router-dom'

import { LegalFooter } from '../page/LegalFooter.tsx'
import { langFromSearch, useDocumentLang } from '../page/documentLang.ts'
import { translator } from '../page/lang.ts'

/**
 * A path release one has no page for.
 *
 * §5.12 asks every page string for both languages, this one included, so it
 * takes its language from `?lang=` the way the two §9.4 pages do rather than
 * being Hungarian whatever the customer is reading.
 */
export function NotFound() {
  const [search] = useSearchParams()
  const { pathname } = useLocation()
  const staff = pathname.startsWith('/staff')
  const lang = langFromSearch(search)
  const t = translator(lang)
  useDocumentLang(lang)
  return (
    <>
      <main className="plt-skeleton" data-testid="not-found">
        <h1>{t('Nincs ilyen oldal', 'No such page')}</h1>
        <p>{t('A keresett oldalt nem találjuk.', 'We cannot find the page you asked for.')}</p>
      </main>
      {/* Legal pages brief, item 3. A wrong /staff address is staff's, not a customer's. */}
      {staff ? null : <LegalFooter lang={lang} />}
    </>
  )
}
